import { FC, useMemo } from "react";
import { Syndicat } from "../../lib/interfaces/syndicat.interface";
import { AtSign, Laptop, Phone } from "lucide-react";
import Title from "../ui/Title";

interface Props {
  syndicat: Syndicat;
}

const MonSyndicat: FC<Props> = ({ syndicat }) => {
  const urlWebsite: string = useMemo(() => {
    if (!!syndicat.site) {
      let url = syndicat.site.trim();
      if (url.startsWith("https://")) return url;
      if (url.startsWith("http://")) return url.replace("http://", "https://");
      return "https://" + url;
    }
    return "";
  }, [syndicat]);

  return (
    <>
      <Title order={3} className="mb-5">
        {syndicat.nom}
      </Title>
      <div className="flex flex-col gap-2">
        {syndicat.telephone && (
          <div className="flex flex-row gap-6">
            <Phone />
            <div>{syndicat.telephone}</div>
          </div>
        )}
        {syndicat.email && (
          <div className="flex flex-row gap-6">
            <AtSign />
            <div>{syndicat.email}</div>
          </div>
        )}
        {urlWebsite && (
          <div className="flex flex-row gap-6">
            <Laptop />
            <div>
              <a href={urlWebsite} target="_blank" rel="noreferrer">
                {urlWebsite}
              </a>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MonSyndicat;
